import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import { propNumber, propStr } from '../../../helpers/custom-prop-types';
import DocumentBodyState from '../../../helpers/window/DocumentBodyState';
import BackgroundThumbnailRow from './BackgroundThumbnailRow';
/**
 * body部の画像サムネイルを取得して背景に表示させるためのコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const BackgroundThumbnailRows = (props) => {
    const { className, rows } = props;
    const { professional: { images: professionalImages }, solution: { images: solutionImages }, } = DocumentBodyState.attributes;
    const parseImages = useCallback(({ className: imageClassName, images, isGrayScale = false }) => images.map((v, i) => ({
        className: imageClassName,
        image: v,
        isGrayScale,
        key: `${imageClassName}_${i}`,
    })), []);
    const chunked = useMemo(() => {
        const professionals = parseImages({
            className: 'professional',
            images: professionalImages,
            isGrayScale: true,
        });
        const solutions = parseImages({
            className: 'solution',
            images: solutionImages,
        });
        const length = Math.min(professionals.length, solutions.length);
        // 顔写真と事例の画像を交互に並べ直す
        const merged = [].concat(...Array.from({ length }, (unused, i) => [
            professionals[i],
            solutions[i],
        ]), professionals.slice(length), solutions.slice(length));
        // n行で折り返す
        return _.chunk(merged, _.round(merged.length / rows)).splice(0, rows);
    }, [parseImages, professionalImages, rows, solutionImages]);
    return (_jsx("div", Object.assign({ className: `background-thumbnail-rows ${className}` }, { children: chunked.map((chunk, i) => (_jsx(BackgroundThumbnailRow
        /* eslint-disable react/no-array-index-key */
        , { 
            /* eslint-disable react/no-array-index-key */
            images: chunk, isReverse: i % 2 === 0 }, i))) })));
};
BackgroundThumbnailRows.propTypes = {
    className: propStr(),
    rows: propNumber(),
};
BackgroundThumbnailRows.defaultProps = {
    className: '',
    rows: 3,
};
export default BackgroundThumbnailRows;
